import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=46e7ab7b&scoped=true&"
import script from "./layoutFooter.vue?vue&type=script&lang=js&"
export * from "./layoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./layoutFooter.vue?vue&type=style&index=0&id=46e7ab7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7ab7b",
  null
  
)

export default component.exports